<template>
    <PaymentModal :dataForPayment="dataForPayment" v-if="dataForPayment" @close="dataForPayment = null" />
</template>

<script>
import PaymentModal from '@/components/PaymentModal.vue'
import { bus } from '@/utils/bus.js'

export default {
    data() {
        return {
            dataForPayment: null
        }
    },
    components: {
        PaymentModal
    },
    created() {
        bus.$on('showPaymentModal', dataForPayment => { this.dataForPayment = dataForPayment });
    }
}
</script>
